import { unstable_generateUtilityClass as generateUtilityClass, unstable_generateUtilityClasses as generateUtilityClasses } from '@mui/utils';
export const getDayCalendarUtilityClass = slot => generateUtilityClass('MuiDayCalendar', slot);
export const dayPickerClasses = generateUtilityClasses('MuiDayCalendar', ['root', 'header', 'weekDayLabel', 'loadingContainer', 'slideTransition', 'monthContainer', 'weekContainer', 'weekNumberLabel', 'weekNumber']);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/x-date-pickers/DateCalendar/dayCalendarClasses.js
// module id = 1339
// module chunks = 0